import { render, staticRenderFns } from "./backupcode.vue?vue&type=template&id=f2b221aa&scoped=true&"
import script from "./backupcode.vue?vue&type=script&lang=js&"
export * from "./backupcode.vue?vue&type=script&lang=js&"
import style0 from "./backupcode.vue?vue&type=style&index=0&id=f2b221aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b221aa",
  null
  
)

export default component.exports